import PureDatePicker from 'react-datepicker';
import styled from 'styled-components';

export default styled(PureDatePicker)`
  width: 100%;
  margin: 0;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: #d4d7de;
  box-shadow: none;
  display: block;
  font-size: 14px;
  padding: 14px;
  word-break: break-word;
  outline: none;
`;
